<template>
  <div>
    <p class="my-1 text-center text-h7 font-weight-medium">
      Congressional seats in {{ postgres.statename }} since 1960
      <span class="text-caption"
        >(<a
          href="https://www.census.gov/data/tables/time-series/dec/apportionment-data-text.html"
          target="_blank"
          >source</a
        >)</span
      >
    </p>
    <div id="apportionment-graph"></div>
  </div>
</template>
<script>
import StateSeatHistory from "../../data/DemographicData/state-apportionment.json";
import { Enums } from "../../data/Config/Config";
import * as d3 from "d3";
export default {
  name: "ApportionmentHistory",
  props: ["statefips"],
  components: {},
  data: () => ({
    StateSeatHistory: StateSeatHistory,
    labels: ["1960", "1970", "1980", "1990", "2000", "2010", "2020"],
    showLabels: false,
    lineWidth: 1,
    labelSize: 2,
    radius: 10,
    padding: 8,
    lineCap: "square",
    //value: StateSeatHistory['34'],
    gradientDirection: "top",
    fill: false,
    type: "trend",
    autoLineWidth: false,
  }),
  mounted: function () {
    this.buildGraph();
  },
  methods: {
    buildGraph() {
      const self = this;
      const data = StateSeatHistory[this.statefips];

      const embedded = this.$store.getters.isEmbedded;

      var margin = { top: 10, right: 30, bottom: 30, left: 30 },
        width = embedded ? 260- margin.left - margin.right : 360 - margin.left - margin.right,
        height = 150 - margin.top - margin.bottom;

      if (this.svg) {
        this.svg.remove();
        this.svg = null;
      }

      if(this.tooltip){
        this.tooltip.remove();
        this.tooltip=null;
      }

      if(this.vertical){
        this.vertical.remove();
        this.vertical=null;
      }


      document.getElementById("apportionment-graph").innerHTML = "";
      let elements = document.getElementsByClassName("apport-tooltip");
      while (elements.length > 1) {
        elements[0].parentNode.removeChild(elements[0]);
      }
      //if (!this.tooltip) {
        // this.tooltip = d3
        //   .select("body")
        //
        this.tooltip = d3
          .select("#apportionment-graph")
          .append("div")
          .style("position", "absolute")
          .classed("apport-tooltip", true)
          .style("z-index", "10")
          .style("visibility", "hidden")
          .style("pointer-events", "none")
          .style("background", "#fffd");
     // }
      //this.$refs.appGraphHolder.innerHTML = '';
      // append the svg object to the body of the page
      this.svg = d3
        .select("#apportionment-graph")
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      this.svg
        .append("rect")
        .attr("width", "100%")
        .attr("height", "100%")
        .attr("opacity", 0);
      if (!this.mainMarker) {
        this.mainMarker = this.svg
          .append("circle")
          .attr("cx", 30)
          .attr("cy", 30)
          .attr("r", 5)
          .style("fill", "none")
          .style("stroke", "black")
          .style("opacity", 0)
          .raise();
      }

      //if (!this.vertical) {
        this.vertical = this.svg
          .append("line")
          .attr("x1", 0)
          .attr("y1", 0)
          .attr("x2", 0)
          .attr("y2", height)
          .style("stroke", "black")
          .style("stroke-opacity", 0.1)
          .style("stroke-width", 6)
          .style("display", "none")
          .lower();
     // }
      const arrYearPositions = [];

      //Not sure why these widths work. Can't figure out what calculation of vars gets to these but the hard coded values work.
      const diffWidth = embedded ? 230 : 350;

      for (let s = 0; s < data.length; s++) {
        //Why 350? margin plus the width of the y-axis label
        
        arrYearPositions.push(diffWidth * (s / data.length));
      }
      this.svg
        .on("mousemove", function (e, i) {
          const pctOnLine = (e.layerX - margin.left) / (width - margin.left);

          const mouseXRel = e.layerX - margin.left;

          var closest = arrYearPositions.reduce((a, b) => {
            return Math.abs(b - mouseXRel) < Math.abs(a - mouseXRel) ? b : a;
          });

          const arrIndexVal = Math.floor(
            (closest / (width - margin.left)) * (data.length - 1)
          );

          self.vertical
            .attr("x1", closest)
            .attr("x2", closest)
            .style("display", "initial");

          // const arrIndexVal = Math.floor(pctOnLine * (data.length - 1));
          // console.log(self.labels[arrIndexVal]);
          // // const arrIndexYears = Math.floor(((e.layerX - margin.left) / (width- margin.left- margin.right)) * data.length)
          self.tooltip.style("visibility", "visible");
          // self.tooltip.html(`${self.labels[arrIndexVal]} - ${self.labels[arrIndexVal + 1] || "present"}
          self.tooltip.html(`${self.labels[arrIndexVal]}:
        <br>
        ${data[arrIndexVal]} seat(s)`);
          let xTooltip = closest + margin.left + 10;
          if (xTooltip + 50 > width + margin.left + margin.right + 10)
            xTooltip = width + margin.left + margin.right + 10 - 50;
          return self.tooltip
            .style("left", xTooltip + 12 + "px")
            .style(
              "top",
              e.clientY -
                height -
                60 -
                margin.bottom -
                margin.top +
                document.getElementsByClassName("district-data-container")[0]
                  .scrollTop +
                "px"
            );
          // .style("left", e.clientX + 10 + "px");
        })
        .on("mouseleave", function () {
          self.tooltip.style("visibility", "hidden");
        });

      var x = d3
        .scaleTime()
        .domain(
          d3.extent(data, function (d, i) {
            return +self.labels[i];
          })
        )
        .range([0, width]);

      this.svg
        .append("g")
        .attr("transform", "translate(0," + height + ")")
        .attr("opacity", 0.5)
        .call(
          d3
            .axisBottom(x)
            .ticks(7)
            .tickFormat((x) => `${+x}`)
        );

      // Add Y axis
      const yDomain = [
        0,
        d3.max(data, function (d) {
          return +d + 1;
          //return +d;
        }),
      ];

      //const yDomain = [0, 53];

      var y = d3.scaleLinear().domain(yDomain).range([height, 0]);

      this.svg
        .append("g")
        .call(
          d3.axisLeft(y).ticks(
            Math.min(
              d3.max(data, function (d) {
                return +d;
              }),
              8
            )
          )
        )
        .attr("opacity", 0.5);

      // Add the line
      this.svg
        .append("path")
        .datum(data)
        .attr("fill", "none")
        .attr("stroke", "steelblue")
        .attr("stroke-width", 4) //1.5
        .attr(
          "d",
          d3
            .line()
            .x(function (d, i) {
              return x(self.labels[i]);
            })
            .y(function (d) {
              return y(+d);
            })
            .curve(d3.curveStepAfter)
        );
      // .on("mouseenter", function (d, i) {
      //   //console.log('mouse enter')
      //   // console.log()
      //   // console.log(d)
      //   //tooltip.text(`${i[Math.ceil(d.layerX/width*data.length)]} seats`);
      //   return tooltip.style("visibility", "visible");
      // })
      // .on("mousemove", function (e, i) {
      //   const pctOnLine = ((e.layerX - margin.left) / (width));
      //    const arrIndexVal = Math.floor(pctOnLine * (data.length-1));
      //    console.log(self.labels[arrIndexVal])
      //   // const arrIndexYears = Math.floor(((e.layerX - margin.left) / (width- margin.left- margin.right)) * data.length)
      //   tooltip.html(`
      //   ${
      //     self.labels[arrIndexVal]
      //   }
      //   -
      //   ${
      //     self.labels[arrIndexVal+1]
      //   }
      //   <br>
      //   ${
      //     i[arrIndexVal]
      //   } seat(s)
      //   `);
      //   return tooltip
      //     .style("top", e.clientY - 20 + "px")
      //     .style("left", e.clientX + 10 + "px");
      // })
      // .on("mouseleave", function (d, i) {
      //   // console.log('mouse leave')
      //   return tooltip.style("visibility", "hidden");
      // });
    },
  },
  watch: {
    statefips: function (val) {
      this.buildGraph();
    },
  },
  computed: {
    postgres: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.POSTGRES] || {}
      );
    },
  },
};
</script>
<style>
#apportionment-graph svg {
  margin: 0 auto;
  display: block;
}
</style>